export default "__VITE_ASSET__gwu86Eb7__"